<ng-container>
  <app-rent-info [controls]="controls"></app-rent-info>

  <div *ngIf="vehiclesOwned && vehiclesOwned.NumberOfVehicles > 0" class="row">
    <div class="col">
      <hr class="hr-style" />

      <h2>Applicant Vehicles</h2>

      <div [formGroup]="vehicleFormGroup">
        <ng-container
          *ngFor="let item of applicantVehicles?.controls; let i = index"
        >
          <app-vehicle-detail-info
            [index]="i"
            [controls]="applicantVehicles!.controls[i]"
          ></app-vehicle-detail-info>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
